import BodyProgress from './BodyProgress';

export default BodyProgress;
